export default {
  'notifications.success.label': 'Geslaagd',
  'notifications.success.generic_message': 'De uitgevoerde actie is geslaagd.',
  'notifications.warning.label': 'Waarschuwing',
  'notifications.errors.label': 'Error',
  'notifications.errors.something_went_wrong':
    'Er is iets fout gegaan. Gelieve opnieuw te proberen.',
};
